import { useMutationBuilder, useQueryBuilder } from "../useBuilders";
import {  ACTION_NEEDED, ACTIVATION, CAPABILITIES, EMAIL_SIGNATURE, FETCH, KEYS, PASSWORD, UPDATE, USER } from "../queryKeys";
import { profileApi } from "src/services/settings/profile";
import { useDispatch } from "react-redux";
import { updatingUserProfileFailed, updatingUserProfileSucceeded } from "src/redux/actions/users";


export const useUserFetch = () => {
  return useQueryBuilder([USER, FETCH], profileApi.fetchUser);
};

export const useUserUpdate = () => {
  const dispatch = useDispatch();
  const mutation = useMutationBuilder([USER, UPDATE], profileApi.updateUser, [USER, FETCH]);

  return {
    ...mutation,
    mutate: (data: any) => {
      mutation.mutate(data, {
        onSuccess: (updatedUser) => {
          // Update Redux state with the response
          dispatch(updatingUserProfileSucceeded(updatedUser));
        },
        onError: (error) => {
          dispatch(updatingUserProfileFailed(error));
        }
      });
    }
  };
}

export const usePasswordUpdate = () => {
  return useMutationBuilder([PASSWORD, UPDATE], profileApi.updatePassword);
}

export const useEmailSignatureUpdate = () => {
  return useMutationBuilder([EMAIL_SIGNATURE, UPDATE], profileApi.updateEmailSignature, [USER, FETCH]);
}

export const useCapabilitiesActionNeededFetch = () => {
  return useQueryBuilder([USER, ACTION_NEEDED ], profileApi.fetchCapabilitiesActionNeeded);
}

export const useActivatedKeysFetch = () => {
    return useQueryBuilder([USER, ACTIVATION, KEYS], profileApi.fetchActivatedKeys);
}

